const contactLinks = [
  {
    icon: 'ri-send-plane-line',
    label: 'Start Planning',
    value: 'Plan your trip',
    href: 'https://alabastertravel.com/plan-your-trip',
  },
  {
    icon: 'ri-global-line',
    label: 'Website',
    value: 'alabastertravel.com',
    href: 'https://alabastertravel.com/',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'hello@alabastertravel.com',
    href: 'mailto:hello@alabastertravel.com',
  },
  {
    icon: 'ri-compass-3-line',
    label: 'Why An Advisor',
    value: 'Why use a travel advisor',
    href: 'https://alabastertravel.com/why-use-an-advisor',
  },
];

export default function AlabasterContact() {
  return (
    <section id="contact" className="bg-primary-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <div>
              <p className="text-accent-400 text-sm font-semibold tracking-widest uppercase mb-3">
                Alabaster Travel
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-6">
                Plan your next trip
              </h2>
              <p className="text-background-300 text-base md:text-lg leading-relaxed max-w-xl mb-8">
                Alabaster Travel is a trade name of Penland LLC. Itinerary design, booking, and
                concierge support all happen on the Alabaster Travel site, where every trip is
                planned around your family.
              </p>
              <a
                href="https://alabastertravel.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm md:text-base font-bold px-8 py-4 rounded-full transition-all whitespace-nowrap"
              >
                Visit Alabaster Travel
                <i className="ri-external-link-line" />
              </a>
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              {contactLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-background-50/5 border border-background-50/10 rounded-xl p-5 hover:bg-background-50/10 transition-colors"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-4">
                    <i className={`${link.icon} text-accent-300 text-lg`} />
                  </div>
                  <p className="text-background-400 text-xs uppercase tracking-wider font-semibold mb-1">
                    {link.label}
                  </p>
                  <p className="text-background-50 text-sm font-medium break-all">
                    {link.value}
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}